import moment from "moment";
import { DateFormatsEnum, formatDate } from "@src/components/utils/dateUtils";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { EventRecord } from "@src/store/pricing/queryEventsSlice";
import { TPayload } from "@src/store/system/helpAndSupportSlice";
import { SalesData } from "@src/pages/home/children/sales/SalesTable/SalesTable.constants";

type TConstructPayload = {
	selectedEvent: EventRecord;
	nameId: string | null;
	emails: Array<string>;
	commonHelp: string;
	additionalInfo?: string;
	userCompanyName: string;
	selectedRow: EventInventoryRecord;
};

export const constructSupportPayload = (data: TConstructPayload): TPayload => ({
	cc_emails: data.emails,
	description: `<p>User Name: ${data.nameId}<p><p>Company Name: ${data.userCompanyName}</p><br/><p>Listing Information</p><ul><li>Event : ${data.selectedEvent?.Event_Headliner}</li><li>Date : ${formatDate(data.selectedEvent?.Event_Date, DateFormatsEnum["MM/DD/YYYY"])}</li><li>Time : ${data.selectedEvent?.Event_Time}</li><li>Venue : ${data.selectedEvent?.Venue_Name}</li><li>Section : ${data.selectedRow?.Section}</li><li>Row : ${data.selectedRow?.Row}</li><li>Seats : ${data.selectedRow?.Seats}</li></ul><br/><p>Additional Information</p><p>${data.additionalInfo ?? "/"}</p><a href="https://portal.stagefront.com/Pricing#listing/${data.selectedRow?.Listing_ID}">Go to Listing</a>`,
	email: data.emails[0],
	subject: `Issue- ${data.commonHelp} ( Listing ID :  ${data.selectedRow?.Listing_ID} )`,
});

type TConstructInvoicePayload = {
	selectedRow: SalesData;
	seats: string;
	nameId: string | null;
	commonHelp: string;
	additionalInfo?: string;
};

export const isInvoiceSupportUrgent = (eventDate: string | null | undefined) => {
	if (!eventDate) return false;
	const daysUntilEvent = moment(eventDate).startOf("day").diff(moment().startOf("day"), "days");
	return daysUntilEvent >= 0 && daysUntilEvent <= 2;
};

const optionalListItem = (label: string, value: string | number | null | undefined) =>
	value ? `<li>${label} : ${value}</li>` : "";

export const constructInvoiceSupportPayload = (data: TConstructInvoicePayload) => {
	const { selectedRow } = data;
	const urgentPrefix = isInvoiceSupportUrgent(selectedRow.Event_Date) ? "URGENT " : "";

	return {
		subject: `${urgentPrefix}Issue- ${data.commonHelp} ( Invoice ID :  ${selectedRow.Invoice_ID} )`,
		description: `<p>User Name: ${data.nameId}<p><p>Company Name: ${selectedRow.Company_Name}</p><br/><p>Invoice Information</p><ul><li>Invoice : ${selectedRow.Invoice_ID}</li><li>Event : ${selectedRow.Event_Name ?? selectedRow.Event_Headliner}</li><li>Date : ${formatDate(selectedRow.Event_Date, DateFormatsEnum["MM/DD/YYYY"])}</li><li>Time : ${selectedRow.Event_Time}</li><li>Venue : ${selectedRow.Venue_Name}</li>${optionalListItem("Section", selectedRow.Section)}${optionalListItem("Row", selectedRow.Row)}${optionalListItem("Seats", data.seats)}${optionalListItem("Internal Notes", selectedRow.Internal_Notes)}${optionalListItem("External Notes", selectedRow.External_Notes)}</ul><br/><p>Additional Information</p><p>${data.additionalInfo || "NONE"}</p><a href="https://portal.stagefront.com/Sales/Fulfillment#invoice/${selectedRow.Invoice_ID}">Go to Invoice</a>`,
	};
};
